var _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEe(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    rx: 5,
    fill: "url(#patternEE)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "patternEE",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_8917_2489",
    transform: "translate(-0.287709) scale(0.00558659)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_8917_2489",
    width: 282,
    height: 179,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAARoAAACzCAIAAADZtUR/AAADp0lEQVR4Ae3UsQ2AMBAEwe+TLlwT3SC5JbuJTZAGEV8w+vXM2n4CBBqBZkWTBAisPXIiQCATyIY8TgQIyIkAgUwgG/IyESAgJwIEMoFsyMtEgICcCBDIBLIhLxMBAnIiQCATyIa8TAQIyIkAgUwgG/IyESAgJwIEMoFsyMtEgICcCBDIBLIhLxMBAnIiQCATyIa8TAQIyIkAgUwgG/IyESAgJwIEMoFsyMtEgICcCBDIBLIhLxMBAnIiQCATyIa8TAQIyIkAgUwgG/IyESAgJwIEMoFsyMtEgICcCBDIBLIhLxMBAnIiQCATyIa8TAQIyIkAgUwgG/IyESAgJwIEMoFsyMtEgICcCBDIBLIhLxMBAnIiQCATyIa8TAQIyIkAgUwgG/IyESAgJwIEMoFsyMtEgICcCBDIBLIhLxMBAnIiQCATyIa8TAQIyIkAgUwgG/IyESAgJwIEMoFsyMtEgICcCBDIBLIhLxMBAnIiQCATmOf1EyDQCIyPAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIEDgfwKfjwCBSGCOjwCBSEBOEaQZAufIyRUQyATklFEaIiAnN0AgE5BTRmmIgJzcAIFMQE4ZpSECcnIDBDIBOWWUhgjIyQ0QyATklFEaIiAnN0AgE5BTRmmIgJzcAIFMQE4ZpSECcnIDBDIBOWWUhgjIyQ0QyATklFEaIiAnN0AgE5BTRmmIgJzcAIFMQE4ZpSECcnIDBDIBOWWUhgjIyQ0QyATklFEaIiAnN0AgE5BTRmmIgJzcAIFMQE4ZpSECcnIDBDIBOWWUhgjIyQ0QyATklFEaIiAnN0AgE5BTRmmIgJzcAIFMQE4ZpSECcnIDBDIBOWWUhgjIyQ0QyATklFEaIiAnN0AgE5BTRmmIgJzcAIFMQE4ZpSECcnIDBDIBOWWUhgjIyQ0QyATklFEaIiAnN0AgE5BTRmmIgJzcAIFMQE4ZpSECcnIDBDIBOWWUhgjIyQ0QyAQuhRY8oKUfvNIAAAAASUVORK5CYII="
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEe);
export default __webpack_public_path__ + "static/media/EE.cd1cbbeac32f208ba0d9bf2f55519d69.svg";
export { ForwardRef as ReactComponent };